<template>
  <el-tag v-if="tag" :type="tag.type" :hit="true" size="small">
    {{ tag.label }}
  </el-tag>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { FeedStateLabels, FeedState } from '@/api/types'

export default defineComponent({
  name: 'FeedState',
  props: {
    state: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const tag = computed(() => {
      const state = props.state as FeedState
      return state === 'approved' ? null : FeedStateLabels[state]
    })

    return { tag }
  }
})
</script>
<style lang="scss" scoped>
.el-tag {
  border: none !important;
}
</style>
